import { Row, Col } from 'react-bootstrap';
import CurrencyField from '../../../fields/CurrencyField';
import AdditionalInformationField from '../../../fields/AdditionalInformationField';
import { MIN_PLEDGE, MAX_CARES_AMOUNT } from '../../../../../constants/constants';

const CaresExceptionRequestSection = ({
  pledgeAmount,
  onPledgeAmountChange,
  exceptionReason,
  onExceptionReasonChange,
  isSubmitting,
}) => {
  return (
    <>
      <hr/>

      <Row>
        <h4>Exception Request</h4>
        <Col md={6}>
          <CurrencyField
            value={pledgeAmount}
            fieldName="Exception Amount"
            min={MIN_PLEDGE}
            max={MAX_CARES_AMOUNT}
            onChange={onPledgeAmountChange}
            disabled={isSubmitting}
            required
          />
        </Col>
      </Row>

      <br/>

      <Row>
        <Col>
          <AdditionalInformationField
            value={exceptionReason}
            fieldName="Exception Reason"
            onChange={onExceptionReasonChange}
            disabled={isSubmitting}
            required
          />
        </Col>
      </Row>
    </>
  );
};

export default CaresExceptionRequestSection;